<template>
  <section class="screen">

<!-- <div class="message"> Thank you! We will be in touch soon!</div> -->

      <!-- <div class="tab"> -->
        <div class="header-tools" @click="$router.push('/dental-radar/' + user.uid)">
          <div class="header-tools__title">Dental Radar
            <img src="/static/camera.svg" alt="">
          </div>
          
        </div>

        <div class="header-tools">
          <div @click="insurance = !insurance" class="header-tools__title highlight">Insurance
            <!-- <img src="/static/camera.svg" alt=""> -->
          </div>
          <div v-if="insurance">
            <!-- insuracnce stuff -->
          </div>

          <div v-if="money">
            <!-- money stuff -->
          </div>
        </div>

        <div class="page-title">{{user.displayName}}</div>

          <div class="page-view">
            <div class="page-view__options" @click="timeline = true; actions = false">
              <svg class="page-view__icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
              <g>
                <line class="st0" :class="{'page-view__active-bg' : timeline}" x1="250" y1="150.5" x2="250" y2="353.6"/>
                <circle class="st0" :class="{'page-view__active-bg' : timeline}" cx="250" cy="106" r="44.5"/>
                <circle class="st0" :class="{'page-view__active-bg' : timeline}" cx="250" cy="394" r="44.5"/>
              </g>
              </svg>
              <span class="page-view__text" :class="{'page-view__active-text' : timeline}">Timeline</span>
            </div>
            <div class="page-view__options" @click="actions = true; timeline = false">
              <svg class="page-view__icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
              <g id="Layer_1">
              </g>
              <g id="Layer_2">
                <polygon class="st0" :class="{'page-view__active-bg' : actions}" points="202,94.1 305.3,94.1 274,195.6 355.1,195.6 189.1,405.9 218.6,269.4 144.9,278.6 	"/>
              </g>
              </svg>
        
              <span class="page-view__text" :class="{'page-view__active-text' : actions }">Actions</span>
            </div>

          </div>


        <template v-if="timeline">

          
          <div class="filter">
            <!-- <div class="filter__item" @click="filter = ''">All</div> -->
            <div class="filter__item" :class="{ 'filter__item-active' :filter == 'AR'}" @click="filterCat('AR')">Requested</div>
            <div class="filter__item" :class="{ 'filter__item-active' :filter == 'UA'}" @click="filterCat('UA')">Upcoming</div>
            <div class="filter__item" :class="{ 'filter__item-active' :filter == 'SA'}" @click="filterCat('SA')">Ongoing</div>
            <div class="filter__item" :class="{ 'filter__item-active' :filter == 'R'}" @click="filterCat('R')">Updates</div>
            <div class="filter__item" :class="{ 'filter__item-active' :filter == 'R1'}" @click="filterCat('R1')">eScripts</div>
            <div class="filter__item" :class="{ 'filter__item-active' :filter == 'BR'}" @click="filterCat('BR')">Follow Ups</div>
          </div>

          <template  v-for="(display, idx) in cards">
            <template v-if="display.type.includes(filter)">
          <div :key="idx" @click="pushCard(display.id, user)" class="tab">
          <!-- <div :key="idx" @click="$router.push('/card/' +  display.id)" class="tab"> -->
              <div class="tab__type" :class="[$options.filters.cardColor(display.type)]"></div>
              <div class="tab__info">
                <div class="tab__name">{{ display.type | cardType}}</div>
                <div v-if="display.description" class="tab__description">{{display.description}}</div>
              </div>

              <div v-if="display.type == 'AR' || display.type == 'BR'" class="tab__media">
                <span class="action">Action Required</span>
              </div>
              <div v-if="display.type == 'MA'" class="tab__media">
                <img src="/static/radar-image.png" alt="dental radar image">
              </div>
          </div>
            </template>
          </template>
        </template>

        <template v-if="actions">


        <div class="options">
          <div @click="appointment(user)" class="bg-1 button">Suggest Appointment</div>
          <div @click="radar(user)" class="bg-1 button">Add Media</div>
          <div @click="messageUser(user)" class="bg-1 button">Message User</div>
          <div @click="assignBalance(user)" class="bg-1 button">Balance Reminder</div>
          <div class="bg-1 button">E-scribe x</div>
          <div class="bg-1 button">Export User History x</div>

        </div>

      </template>

      <!-- </div> -->







  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'
import { firestore } from "../main";
import * as firebase from "firebase";
import { mapMutations, mapGetters } from 'vuex'
import router from '../router';



export default {
  name: 'heroSection',
  data () {
    return {
        user: {},
        cards: {},
        filter: '',
        insurance: false,
        money: false,
        timeline: true,
        actions: false,
        activePage: null
    }
  },
  watch: {
    $route (to, from){
    }
  },
  methods: {
    appointment(payload){
      // this.$store.dispatch("options");
      this.$store.state.activePatient.payload = payload
      this.$store.state.activePatient.active= true
      this.$router.push('/appointment')
    },
    pushCard(payload, user) {
      this.$store.state.activePatient.payload = user
      this.$store.state.activePatient.active= true 
      this.$router.push('/card/' +  payload)
    },
    filterCat(payload) {
      return this.filter == payload
      ? this.filter = ''
      : this.filter = payload
    },
    radar(payload){
      // this.$store.dispatch("options");
      this.$store.state.activePatient.payload = payload
      this.$store.state.activePatient.active= true
      this.$router.push('/dental-radar')
    },
    messageUser(payload) {
      this.$router.push('/messages/' + payload.uid)
    },
    assignBalance(payload) {
      this.$store.state.activePatient.payload = payload
      this.$store.state.activePatient.active= true
      this.$router.push('/assign-balance')
    }
  },
  firestore() {
    this.activePage  = this.$route.path.split('/user/')[1]

    return {
      user: firestore.collection('users').doc(this.activePage),
      cards: firestore.collection('cards').where("uid", "==", this.activePage).orderBy('createdAt', 'desc')
  }
},
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

  .header-tools {
    width: 90%;
    margin: 0 auto 50px auto;
    display: flex;
    justify-content: right;
    align-items: center;
    position: relative;
    height: auto;

    &__title {
      text-align: right;
      color: #eee;
      margin-right: 2px;
      position: absolute;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      height: 30px;

    }
    img {
      width: 30px;
      margin-left: 10px;
    }
  }
  .highlight  {
    background-color: #fff;
    color: #000;
    padding: 0 5px;
    border-radius: 5px;
    letter-spacing: 1.2pt;
  }

  .st0{fill:none;stroke:#aaa;stroke-width:12;stroke-miterlimit:10;}

  .page-view {
    width: 90%;
    margin: 20px auto;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    &__text {
      color: #aaa;
    }
    &__active-text {
      color: #fff;
    }
    &__active-bg {
      stroke: #fff;
    }
    
    &__options {
      width: 40%;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    }
    &__icon {
      width: 25px;
      margin-right: 10px;
    }
  }

  .action {
    background-color: transparent;
    border: 1px solid #de7c5e;
    color: #de7c5e;
    font-size: 8px;
    padding: 5px 10px;
    border-radius: 5px;
  }
  .filter {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: wrap;
    width: 100%;
    margin: 1em 0 2em 0;

    &__item {
      width: 30%;
      background-color: #70c8df;
      border: 1px solid #70c8df;
      margin: 1%;
      color: #fff;
      padding: 1% 0.5%;
      border-radius: 3px;
      text-transform: uppercase;
      font-weight: 500;
    }
    &__item-active {
      width: 30%;
      background-color: transparent;
      border: 1px solid #70c8df;
      margin: 1%;
      color: #fff;
      padding: 1% 0.5%;
      border-radius: 3px;
      text-transform: uppercase;
      font-weight: 500;
    }
  }

.options {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: wrap;

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 1px solid #70c8df;
    margin: 2vw;

    width: 40vw;
    height: 40vw;
    border-radius: 10px;
    font-size: 4vw;
    text-align: left;
    font-weight: bold;
  }

}

.screen {
    // display: flex;
    // flex-direction: column;
    position: relative;
    margin-top: 80px;
    padding: 20px 0 100px 0;
    width: 100%;
    // align-items: center;
    height: auto;
    .tab {
        width: 90%;
        height: auto;
        padding: 20px 30px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: left;
        justify-content: center;
        color: #fff;
        // background-color: #eee;
        border-left: 1px solid #fff;
        cursor: pointer;
        @media screen and (max-width: $break-small) {

        }

        h2 {
          font-size: 1.5vw;
          text-align: left;
          text-transform: uppercase;
          font-family: "futura", sans-serif;
          font-weight: 500;
          letter-spacing: 1px;
          @media screen and (max-width: $break-small) {
            font-size: 3vw;

          }
        }
 
        &__type {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 7.5px);
            left: -7.5px;
        }
        &__info {
          padding: 5px;
          border-radius: 15px;
          border-bottom-left-radius: 0;
          // background-color: #00d398;
        }

        &__media {
          width: 40%;
          right: 0;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 70%;
            border-radius: 10px;
          }
        }
            // sub settings of type
            .orange {
                background-color: $accentColor;
            }
            .yellow {
                background-color: #f8e85b;
            }
            .media {
                width: 30px;
                height: 30px;
                margin-left: -5px;
                img {
                    width: 20px;
                }
            }
            .grey {
                background-color: #ddd;
            }
        &__name {
            width: 70%;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
        }
        &__description{
            width: 70%;
            text-align: left;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            padding: 2px 0;
        }
    }
    
    // .tab {
    //     width: 90%;
    //     height: auto;
    //     padding: 20px 0;
    //     // background-color: #fff;
    //     // box-shadow: 1px 1px 2px rgb(195, 202, 211);
    //     border-radius: 5px;
    //     margin: 5px 0;
    //     display: flex;
    //     flex-direction: column;
    //     position: relative;
    //     align-items: center;
    //     justify-content: center;
    //     color: #777;

    //     hr {
    //         border: 1px solid #42455e;
    //         // border-top: 1px solid #42455e;

    //         color: #42455e;
    //         margin: 1em 0;
    //         width: 98%;
    //     }
 

    //     &__type {
    //         background-color: $accentColor;
    //         width: 15px;
    //         height: 15px;
    //         border-radius: 50%;
    //         position: absolute;
    //         top: calc(50% - 7.5px);
    //         left: 20px;
    //     }
    //         // type color
    //         .active {
    //             background-color: $brandColor
    //         }
    //         .inactive {
    //             background-color: #ddd
    //         }
    //     &__name {
    //         width: 70%;
    //         text-align: left;
    //         font-weight: 600;
    //         font-size: 16px;
    //     }
    //     &__description{
    //         width: 70%;
    //         text-align: left;
    //         font-weight: 300;
    //         font-size: 14px;
    //         font-style: italic;
    //         padding: 2px 0;
    //     }
    // }
    
}


  
</style>



// WEBPACK FOOTER //
// src/components/UserPage.vue